import { useRef, useState } from 'react'
import logo from '../assets/icons/logo-completo-defensoria.png'
import NavBar from './NavBar'
import ResponsiveContainer from './ResponsiveContainer'
import { MdDehaze } from "react-icons/md";
import './styles.css'
import useClickOutside from '../hooks/useClickOutside';

const Header = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };

  useClickOutside(navRef, toggleMenu);

  return (
    <nav className='w-full'>
      <div className='h-[6.25rem] py-6 flex justify-center header-desing'>
        <ResponsiveContainer className='flex justify-between items-center'>
          <img src={logo} alt='Logo defensoria del pueblo' className='h-[2rem] w-[9.35rem] md:h-fit md:w-fit' />
          <button onClick={toggleMenu} className='md:hidden'>
            <MdDehaze size={24} color={'white'} />
          </button>
        </ResponsiveContainer>
      </div>
      {/* Navbar in screen md and > */}
      <div className='hidden md:flex md:justify-center'>
        <ResponsiveContainer>
          <NavBar />
        </ResponsiveContainer>
      </div>
      {/* Navbar in mobile */}
      {
        isMenuVisible && (
          <div
            className='w-[338px] p-3 absolute bg-primary-100 right-0 z-[3500] rounded-b-xl shadow-custom-dual'
            ref={navRef}
          >
            <NavBar />
          </div>
        )
      }
    </nav>
  )
}

export default Header